import React from "react";

const DashboardSkeleton: React.FC = () => {
  return (
    <div className="px-8 pb-3 flex-1 flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 mt-4 min-h-[2.475rem] max-h-[2.475rem] 2xl:min-h-[2.75rem] 2xl:max-h-[2.75rem]">
        <div>
          <div className="w-48 h-6 bg-gray-200 rounded mb-1" />
          <div className="w-64 h-4 bg-gray-200 rounded" />
        </div>
        <div className="flex items-center space-x-6">
          <div className="w-24 h-8 bg-gray-300 rounded-lg" />
        </div>
      </div>

      <hr className="ml-[-3rem] mr-[-3rem] my-2" />

      {/* Tabs and Sorting */}
      <div className="mt-6 mb-6 flex justify-between">
        <div className="flex space-x-6">
          <div className="w-36 h-6 bg-gray-300 rounded" />
          <div className="w-36 h-6 bg-gray-200 rounded" />
        </div>
        <div className="w-24 h-8 bg-gray-200 rounded" />
      </div>

      {/* Project Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        {Array.from({ length: 6 }).map((_, idx) => (
          <div
            key={idx}
            className="p-4 w-full bg-white rounded-lg border border-gray-300 flex flex-col relative"
          >
            {/* Date & Avatar */}
            <div className="flex justify-between items-center mb-2">
              <div className="w-20 h-3 bg-gray-300 rounded" />
              <div className="w-8 h-8 bg-gray-300 rounded-full" />
            </div>

            {/* Title */}
            <div className="h-5 w-3/4 bg-gray-300 rounded mb-2" />

            {/* Description (4-line clamp height) */}
            <div className="space-y-1 mb-2">
              <div className="h-4 w-full bg-gray-200 rounded" />
              <div className="h-4 w-11/12 bg-gray-200 rounded" />
              <div className="h-4 w-10/12 bg-gray-200 rounded" />
              <div className="h-4 w-9/12 bg-gray-200 rounded" />
            </div>

            {/* Footer: Created by + file count */}
            <div className="flex justify-between items-center mt-4">
              <div className="h-4 w-1/2 bg-gray-200 rounded" />
              <div className="h-4 w-10 bg-gray-200 rounded" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardSkeleton;
